import { getCorporateSiteLocale } from "@/utils/getCorporateSiteLocale";

import { useExperience } from "./useExperience";

export const useCorporateSiteLocalePath = () => {
  const { cookieCountry, pathLanguage, userLanguage } = useExperience();
  const locale = cookieCountry
    ? getCorporateSiteLocale(cookieCountry.iso2, pathLanguage?.iso2 || userLanguage?.iso2)
    : null;
  return locale ? `/${locale}` : "";
};
